exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-snack__content {\r\n  padding: 14px 10px;\n}\r\n", ""]);

// exports
